/**
 * Liveness beacon for the sync engine's stall guard.
 *
 * The guard's primary progress signal is the confirmed version advancing —
 * but a gap catch-up download runs BEFORE any action applies, so version
 * stands still for the whole fetch. Without a second signal, a slow-but-alive
 * download would trip the guard before its own abort timeout. The catch-up
 * downloaders bump this beacon when they start and when they settle
 * (success, error, or abort — every outcome is liveness; only a request that
 * never calls back bumps nothing), and the guard treats a bump as progress.
 *
 * Module-level on purpose: the downloaders are constructed in the client
 * layer and the guard lives in the engine, and threading a counter through
 * that construction chain buys no isolation worth the plumbing — one round
 * is mounted at a time, and a false "alive" from another consumer merely
 * delays a stall report by one window.
 */
let activityCount = 0;

export function bumpSyncActivity(): void {
  activityCount += 1;
}

export function getSyncActivityCount(): number {
  return activityCount;
}
